import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryEffects } from './category.effects';
import { categoryReducer } from './category.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('category', categoryReducer),
    EffectsModule.forFeature([CategoryEffects]),
  ],
  providers: [],
})
export class CategoryStoreModule {}
